/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../types/graph';

import * as Operations from './mutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateNewSpousalAppMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.CreateNewSpousalAppInput;
}>;


export type CreateNewSpousalAppMutation = { __typename?: 'Mutation', customers: { __typename?: 'CustomersMutation', create_new_spousal_app: { __typename?: 'CreateNewSpousalApp', customer: { __typename?: 'Customer', id: string } | null, life_application: { __typename?: 'LifeApplication', id: string } | null } | null } };


export function useCreateNewSpousalAppMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewSpousalAppMutation, CreateNewSpousalAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewSpousalAppMutation, CreateNewSpousalAppMutationVariables>(Operations.CreateNewSpousalApp, options);
      }
export type CreateNewSpousalAppMutationHookResult = ReturnType<typeof useCreateNewSpousalAppMutation>;